import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const faqs = [
  {
    q: "What is Northwest Tech Alliance?",
    a: "Northwest Tech Alliance is the national, technology-focused brand of Northwest Title Alliance. It builds underwriting-grade AI software — the AXIOM family and ART — for title agents, lenders, attorneys, and agencies in all fifty states.",
  },
  {
    q: "What is AXIOM?",
    a: "AXIOM is an underwriting-grade AI assistant for the title industry. Ask a question in any state and get the requirements to insure, sourced correctly the first time — with one-click escalation to counsel-grade or claims-grade depth. It is built on how title professionals actually assess risk, not a generic chatbot.",
  },
  {
    q: "Which AXIOM products are available today?",
    a: "AXIOM for Underwriters, AXIOM for Lenders, AXIOM for Agents, and AXIOM for Attorneys are live now. AXIOM for National Agencies and AXIOM for Commercial Transactions are coming soon.",
  },
  {
    q: "What is ART — AI Rendered Title?",
    a: "ART is an OIC-compliant, AI-powered title plant back to State Patent. It fundamentally changes how title searches are performed — what once took days now takes minutes, fast and accurate for the modern title professional.",
  },
  {
    q: "Who is AXIOM built for?",
    a: "Title underwriters, title agents, lenders, attorneys, national agencies, and commercial transaction teams — anyone who has to clear a file and needs cited, underwriting-grade answers rather than guesses.",
  },
  {
    q: "How do I request a demo or pricing?",
    a: "Email sales@northwesttitlealliance.com or call (253) 453-1754. Someone from the team will respond within one business day.",
  },
];

export const FAQ = () => (
  <section id="faq" className="relative bg-navy py-24 md:py-36" data-testid="faq-section">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-20"
      >
        <div className="md:col-span-3">
          <span className="font-mono-accent text-[11px] tracking-[0.35em] uppercase text-tech-bright">03 / Answers</span>
        </div>
        <div className="md:col-span-9">
          <h2 className="font-display font-bold tracking-[-0.03em] leading-[1.02] text-4xl sm:text-5xl lg:text-6xl text-fog">
            Asked, answered<span className="text-tech">.</span>
          </h2>
        </div>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16">
        {faqs.map((f, i) => (
          <motion.div
            key={f.q}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: EASE }}
            className="border-t border-steel/30 py-8"
            data-testid={`faq-item-${i}`}
          >
            <h3 className="font-display font-semibold tracking-tight text-lg md:text-xl text-fog mb-3">
              <span className="font-mono-accent text-xs text-tech-bright mr-3">{String(i + 1).padStart(2, "0")}</span>
              {f.q}
            </h3>
            <p className="text-sm md:text-base text-fog/60 leading-relaxed pl-9">{f.a}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
